import { Principal } from "@dfinity/principal";

export const MAINNET_LEDGER_CANISTER_ID = Principal.fromText(
  "ryjl3-tyaaa-aaaaa-aaaba-cai",
);

export const MAINNET_INDEX_CANISTER_ID = Principal.fromText(
  "qhbym-qaaaa-aaaaa-aaafq-cai",
);
